import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { SvgIconTypeMap } from "@mui/material";

const ExceptionsIcon: OverridableComponent<
  SvgIconTypeMap<{}, "svg">
> & { muiName: string } = (props: SvgIconProps) => {
  const { width = 72, height = 72, color = "#9E233A", ...otherProps } = props;

  return (
    <SvgIcon
      {...otherProps}
      viewBox="0 0 72 72"
      sx={{ width, height }}
    >
      <g id="exceptions">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.047 3C40.577 3 41.086 3.211 41.461 3.586L59.414 21.539C59.789 21.914 60 22.423 60 22.953V38.5C58.5 37.8 56.9 37.5 55.2 37.2V25.313H37.688V8.667H15.667C15.115 8.667 14.667 9.115 14.667 9.667V60.083C14.667 60.635 15.115 61.083 15.667 61.083H36.5C37.3 63.1 38.5 65 40 66.75H15.375C13.684 66.75 12.063 66.078 10.867 64.883C9.672 63.687 9 62.066 9 60.375V9.375C9 7.684 9.672 6.063 10.867 4.867C12.063 3.672 13.684 3 15.375 3H40.047ZM21.75 46.917H34C33.3 48.5 32.8 50.2 32.5 52.583H21.75V46.917ZM21.75 35.583H47.25V41.25H21.75V35.583Z"
          fill={color}
        />
        <path
          d="M55.5 40C55.1 40 54.7 40.2 54.5 40.6L40.5 64.6C40.1 65.3 40.6 66.2 41.4 66.2H69.6C70.4 66.2 70.9 65.3 70.5 64.6L56.5 40.6C56.3 40.2 55.9 40 55.5 40ZM56.8 62H54.2V59.4H56.8V62ZM56.8 57.2H54.2V49.4H56.8V57.2Z"
          fill={color}
        />
      </g>
    </SvgIcon>
  );
};

ExceptionsIcon.muiName = "SvgIcon";

export default ExceptionsIcon;
